import { createClient } from '@/utils/supabase/client';
import type { TarotReading } from './types';

/**
 * 保存塔罗牌解读结果（仅浏览器 / Client Component）
 */
export async function saveTarotReading(reading: TarotReading) {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('tarot_readings')
    .insert([reading])
    .select('id, share_id')
    .single();

  if (error) {
    console.error('Error saving tarot reading:', error);
    return null;
  }

  return data;
}

/**
 * 记录分享行为（仅浏览器 / Client Component）
 */
export async function recordShare(
  readingId: string,
  platform: string,
  ipAddress?: string
) {
  const supabase = createClient();
  const { error } = await supabase.from('reading_shares').insert([
    {
      reading_id: readingId,
      platform,
      ip_address: ipAddress,
    },
  ]);

  if (error) {
    console.error('Error recording share:', error);
    return false;
  }

  return true;
}
